module.exports = __webpack_public_path__ + "static/media/homeImg.8ab8a751.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeImg.png
// module id = 1296
// module chunks = 1